var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"Content"}},[_c('Header'),_vm._v(" "),_c('b-container',{attrs:{"fluid":""}},[_c('b-row',[_c('LeftNav',{attrs:{"items":_vm.navbarItems}}),_vm._v(" "),_c('b-col',[_c('b-row',[_c('b-col',{staticClass:"new-config px-5 py-3"},[_c('router-view')],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-687a1db4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/content/Index.vue
// module id = null
// module chunks = 